import Store from './Store';

export default Store;



// WEBPACK FOOTER //
// ./src/scenes/CityStores/components/Store/index.ts